import React from 'react'
import Pagination from 'react-js-pagination'
import { connect } from 'react-redux'
import Modal from 'react-responsive-modal'
import AttractionCreateMapping from '../../Containers/Attraction/AttractionCreateMapping'
import AttractionActions from '../../Redux/AttractionRedux'
import DestinationActions from '../../Redux/DestinationRedux'

class AttractionMapping extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      showModal: null,
      setting: {
        q: '',
        ...props.setting,
        type: 'attraction',
        provider: 'BMG'
      },
      destination: '',
      detail: {},
      page: 1,
      attractions: {},
      tab: 'places'
    }
  }

  componentDidMount () {
    this.props.getDestination()
  }

  componentWillReceiveProps = (newProps) => {
    let id = null
    if (newProps.destination.data.length) {
      id = newProps.destination.data[0].id
    }
    if (newProps.destination.data.length && !this.state.destination) {
      this.setState({ destination: id })
      this._fetchAttraction({ destination: id })
    }
    if ((!this.state.showModal) && !newProps.destination.err) this.setState({ attractions: newProps.attraction })
  }

  _inputChange = (event, field) => {
    const val = event.target.value
    let newState = { ...this.state }
    newState[field] = val
    this.setState(newState)
  }

  _toggleModal = (modalId = null) => {
    this.setState({
      showModal: modalId
    })
  }

  _changeTab = (tab = 'attractions') => {
    this.setState({ tab, page: 1 })
    this._fetchAttraction({ tab, destination: this.state.destination })
  }

  _fetchAttraction = ({ setting, destination, page, tab }, event) => {
    if (event) event.preventDefault()
    const data = {
      destination,
      filter: {
        ...setting,
        page
      }
    }
    this.props.getPlace(data)
  }

  _destinationSelect = (event) => {
    const val = event.target.value
    this.setState({ destination: val })
    this._fetchAttraction({ destination: val, tab: this.state.tab })
  }

  _selectAttraction = (item = {}, action = '') => {
    this._toggleModal(action)
    this.setState({ detail: item })
  }

  _delete = () => {
    const data = {
      place_id: this.state.detail.id,
      destination_id: this.state.destination,
      type: this.state.detail.place_type
    }
    this.props.deletePlace(data)
    setTimeout(() => {
      this._toggleModal()
    }, 250)
  }

  _changePage = (page) => {
    this.setState({ page })
    const { setting, destination } = this.state
    const data = {
      destination,
      filter: {
        ...setting,
        page
      }
    }
    this.props.getPlace(data)
  }

  _filterChange = (event, field) => {
    let newState = { ...this.state.setting }
    const val = event.target.value
    newState[field] = val
    this.setState({ setting: newState })
    const data = {
      destination: this.state.destination,
      filter: {
        ...newState,
        page: 1
      }
    }
    this.props.getPlace(data)
  }

  render () {
    const { destination, attraction } = this.props
    const { attractions } = this.state
    return (
      <div>
        <header className='section'>
          <div className='title-block d-flex mb-3 justify-content-between'>
            <h3 className='title mr-auto'>
              Attractions & Places Mapping
              {
                (attraction.fetching || attraction.processing) &&
                <div className='badge badge-info ml-2'>{attraction.fetching ? 'Loading' : 'Processing'} ...</div>
              }
            </h3>
            <button className='btn btn-primary' onClick={() => this._toggleModal('mapping-place')}>Create Mapping</button>
          </div>
          <div className='title-block'>
            <p className='title-description'>Filter:</p>
            <div className='form-inline d-flex justify-content-between'>
              <div className='form-inline'>
                <div className='form-group'>
                  <label className='control-label'>Destination</label>
                </div>
                <div className='form-group ml-2'>
                  <select className='form-control' value={this.state.destination} onChange={event => this._destinationSelect(event)}>
                    <option value='' disabled>- Select Destination -</option>
                    {
                      destination.data && destination.data.map((item, i) => {
                        return (
                          <option key={i} value={item.id}>{item.name}</option>
                        )
                      })
                    }
                  </select>
                </div>
                {/* <div className='form-group ml-2'>
                  <label className='control-label'>Place Type</label>
                </div>
                <div className='form-group ml-2'>
                  <select className='form-control' value={this.state.setting.type} onChange={event => this._filterChange(event, 'type')}>
                    <option value=''>- All Type -</option>
                    <option value='attraction'>Attraction</option>
                    <option value='landmark'>Landmark</option>
                  </select>
                </div> */}
                <div className='form-group ml-2'>
                  <label className='control-label'>Provider</label>
                </div>
                <div className='form-group ml-2'>
                  <select className='form-control' value={this.state.setting.provider} onChange={event => this._filterChange(event, 'provider')}>
                    <option value='BMG'>BMG</option>
                    <option value='KLOOK'>KLOOK</option>
                  </select>
                </div>
              </div>

              <form className='form-inline' onSubmit={(e) => this._fetchAttraction({ destination: this.state.destination, setting: this.state.setting }, e)}>
                <div className='form-group'>
                  <label className='control-label mr-2'>Search by title</label>
                  <input type='text' name='title' className='form-control' onChange={event => this._filterChange(event, 'q')} />
                </div>
                <div className='form-group ml-1 mt-1'>
                  <button type='submit' className='btn btn-primary'>Apply Filter</button>
                </div>
              </form>
            </div>
          </div>
        </header>
        <section className='section'>
          {
            attraction.err &&
            <div className='alert alert-danger'><strong>Attraction : </strong> {attraction.err}</div>
          }
          {
            destination.err &&
            <div className='alert alert-danger'><strong>Destination : </strong> {destination.err}</div>
          }
          {
            (this.state.destination && attractions.data) &&
            <div className='card'>
              <div className='card-block'>
                <table className='table table-striped table-hover' style={{ minWidth: '100%' }}>
                  <thead>
                    <tr>
                      <th>Title</th>
                      <th>Provider</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {
                      (attractions.data.data && attractions.data.data.length) ? attractions.data.data.map((item, i) => {
                        return (
                          <tr key={i}>
                            <td data-filter='title'>{this.state.tab === 'places' && <strong>[ {item.place_type} ]</strong> } {item.title || '-'}</td>
                            <td>{ item.provider || '-' }</td>
                            <td>
                              <button className='btn btn-danger' onClick={() => this._selectAttraction(item, 'delete')}>
                                <i className='fa fa-trash' />
                              </button>
                            </td>
                          </tr>
                        )
                      })
                        : <tr>
                          <td colSpan='3' className='text-center'>- No Data -</td>
                        </tr>
                    }
                  </tbody>
                </table>
              </div>
            </div>
          }
          {/* CREATE MAPPING */}
          <Modal open={this.state.showModal === 'mapping-place'} onClose={this._toggleModal} closeOnOverlayClick>
            <AttractionCreateMapping closeModal={() => this._toggleModal()} type='place' />
          </Modal>

          {/* DELETE MAPPING */}
          <Modal open={this.state.showModal === 'delete'} onClose={this._toggleModal} closeOnOverlayClick>
            <section className='section' style={{ width: '30vw' }}>
              <div className='title-block'>
                <h3>Delete { this.state.tab } from Destination?</h3>
              </div>
              <div className='d-flex justify-content-center'>
                <button className='btn btn-lg btn-secondary mr-2' onClick={() => this._toggleModal()}>Close</button>
                <button className='btn btn-lg btn-danger' onClick={() => this._delete()}>Delete</button>
              </div>
            </section>
          </Modal>
        </section>

        <section className='text-center'>
          {
            ((this.state.destination && attractions.data) && attractions.data.total > 10) &&
            <Pagination
              innerClass='pagination'
              itemClass='page-item'
              linkClass='page-link'
              activePage={attraction.data.page || this.state.page}
              itemsCountPerPage={10}
              totalItemsCount={attractions.data.total}
              pageRangeDisplayed={5}
              onChange={this._changePage}
            />
          }
        </section>
      </div>
    )
  }
}

const stateToProps = (state) => ({
  destination: state.destination,
  attraction: state.attraction,
  preset: state.preset,
  setting: state.preset.setting
})

const dispatchToProps = (dispatch) => ({
  getDestination: () => dispatch(DestinationActions.destinationRequest()),
  getAttraction: (data) => dispatch(AttractionActions.attractionRequest(data)),
  getPlace: (data) => dispatch(AttractionActions.placeRequest(data)),
  deleteAttraction: (data) => dispatch(DestinationActions.deleteAttractionFromDestinationRequest(data)),
  deletePlace: (data) => dispatch(DestinationActions.deletePlaceFromDestinationRequest(data))
})

export default connect(stateToProps, dispatchToProps)(AttractionMapping)



// WEBPACK FOOTER //
// ./src/Pages/Attraction/AttractionMapping.js